import { type FC, type ReactNode, useMemo } from "react";
import { useApolloClient } from "@apollo/client";
import { createPaginationService, createPaginationContext } from "../../common/state";
import { loadLenses } from "./loadLenses";

export const LensListPaginationContext = createPaginationContext();

export const LensListPaginationProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const client = useApolloClient();
    const paginationService = useMemo(() => createPaginationService(loadLenses(client), { limit: 20 }), [client]);

    return (
        <LensListPaginationContext.Provider value={paginationService}>{children}</LensListPaginationContext.Provider>
    );
};
